import React, { useEffect, useMemo } from "react";
import { Result, Button } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthenticatedRoute from "./AuthenticatedRoute";
import { Helmet } from "react-helmet";

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // URLパラメータからタイプを取得
  const purchaseType = searchParams.get("type");
  const isBonusCredit = purchaseType === "bonus_credit";

  const isTrial = purchaseType === "trial";

  const content = useMemo(() => {
    if (isBonusCredit) {
      return {
        title: "ボーナスクレジットの購入が完了しました！",
        subTitle: "購入したクレジットはすぐにご利用いただけます。",
        pageTitle: "ボーナスクレジット購入完了",
        buttonText: "ボーナスクレジット購入へ戻る",
        buttonPath: "/bonus-credit",
      };
    }
    if (isTrial) {
      return {
        title: "14日間無料トライアルが開始されました！",
        subTitle: "トライアル期間中は選択したプランの全機能をご利用いただけます。期間終了後は自動的に有料プランに移行します。",
        pageTitle: "トライアル開始",
        buttonText: "さっそく使ってみる",
        buttonPath: "/aio/dashboard",
      };
    }
    return {
      title: "プランの変更が完了しました！",
      subTitle: "新しいプランでのご利用をお楽しみください。",
      pageTitle: "プラン変更が完了しました",
      buttonText: "サブスクリプション管理へ",
      buttonPath: "/subscription-management",
    };
  }, [isBonusCredit, isTrial]);

  useEffect(() => {
    // ここでバックエンドAPIを呼び出して、セッションIDを検証し、
    // 必要な場合はユーザーの情報を更新します
  }, []);

  return (
    <>
      <Helmet>
        <title>{content.pageTitle} | magicss</title>
        <meta name="robots" content="noindex" />
        <meta
          property="og:title"
          content={`${content.pageTitle} | magicss`}
        />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={window.location.href} />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/img/ogp.png`}
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <AuthenticatedRoute>
        <Result
          status="success"
          title={content.title}
          subTitle={content.subTitle}
          extra={[
            <Button
              key="console"
              onClick={() => navigate(content.buttonPath)}
            >
              {content.buttonText}
            </Button>,
          ]}
        />
      </AuthenticatedRoute>
    </>
  );
};

export default SubscriptionSuccess;
